import React, { useEffect, useState } from 'react';
import aiProcess01 from '../../assets/img/contents/ai-process01.png';
import aiProcess02 from '../../assets/img/contents/ai-process02.png';
import aiProcess03 from '../../assets/img/contents/ai-process03.png';

const Guide = () => {
  useEffect(() => {
    document.title = 'AI 영상 분석 서비스 신청 절차';
  }, []);

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">신청절차</h2>
      </div>
      <div className="tbl-wrap">
        <h3 className="block-tit">AI 영상 분석 서비스 신청 절차</h3>
        <div className="block-cont">
          <div className="ai-process">
            <div className="ai-process-item">
              <p className="step">Step. 01</p>
              <p className="title">작업정보 등록</p>
            </div>
            <div className="ai-process-chevron"></div>
            <div className="ai-process-item">
              <p className="step">Step. 02</p>
              <p className="title">AI영상분석 신청</p>
            </div>
            <div className="ai-process-chevron"></div>
            <div className="ai-process-item">
              <p className="step">Step. 03</p>
              <p className="title">분석결과 조회</p>
            </div>
          </div>
          <div className="ai-process-detail">
            <div className="detail-item">
              <div className="detail-item-header">
                <p className="step">Step.01</p>
                <p className="title">작업정보 등록</p>
                <a
                  href="../../resources/img/contents/ai-process01.png"
                  className="btn xsm tertiary ico-go mob-only"
                  target="_blank"
                >
                  이미지 크게보기
                </a>
              </div>
              <div className="detail-item-body">
                <img src={aiProcess01} alt="신청절차_작업정보등록" />
              </div>
            </div>
            <div className="detail-item">
              <div className="detail-item-header">
                <p className="step">Step.02</p>
                <p className="title">AI영상분석 신청</p>
                <a
                  href="../../resources/img/contents/ai-process02.png"
                  className="btn xsm tertiary ico-go mob-only"
                  target="_blank"
                >
                  이미지 크게보기
                </a>
              </div>
              <div className="detail-item-body">
                <img src={aiProcess02} alt="신청절차_AI영상분석 신청" />
              </div>
            </div>
            <div className="detail-item">
              <div className="detail-item-header">
                <p className="step">Step.03</p>
                <p className="title">분석결과 조회</p>
                <a
                  href="../../resources/img/contents/ai-process03.png"
                  className="btn xsm tertiary ico-go mob-only"
                  target="_blank"
                >
                  이미지 크게보기
                </a>
              </div>
              <div className="detail-item-body">
                <img src={aiProcess03} alt="신청절차_분석결과 조회" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Guide;
